/** Cards de aviso de los mapas del wizard de registro de finca (pasos 3 y 4).
 *
 *  Los dos mapas muestran lo mismo arriba: una fila con el **nombre del paso**
 *  (permanente — es lo que le dice al usuario qué tiene que hacer) y, al lado,
 *  la **ayuda de la herramienta activa** (aparece y desaparece con ella). El
 *  markup de esa fila vive acá y no duplicado en cada render: son el mismo
 *  card, con la misma clase global del sistema (`sx-alert sx-alert-info`,
 *  mismo criterio que la app de referencia externa, que tampoco duplica el
 *  estilo de su card de notificaciones para esto) y la misma fila
 *  (`.map-aviso-row`/`.map-aviso-card`, en `map.css`).
 */

/** Ícono del card de ayuda de la herramienta activa. */
const ICONO_AYUDA = "ph-info";

/** Ícono del card de error — el mismo que usa el card de error del sistema. */
const ICONO_ERROR = "ph-x-circle";

/** El card del nombre del paso: qué dice y con qué ícono se pinta. Los dos
 *  datos van juntos porque el ícono ES del paso —cada uno usa el suyo— y
 *  separarlos deja abierta la puerta a que uno cambie sin el otro. */
export interface AvisoPaso {
  texto: string | null;
  /** Clase del ícono Phosphor, sin el prefijo `ph` (ej. `"ph-polygon"`). */
  icono: string;
}

/** Contenido de la fila de avisos: el nombre del paso y, al lado, la ayuda de
 *  la herramienta activa — o un `error`, si hay.
 *
 *  Un error **desplaza** la ayuda en vez de sumarse a ella: es lo urgente, y
 *  así la fila nunca pasa de dos cards, que es lo que entra en un renglón.
 *
 *  Cada texto vacío o `null` simplemente no pinta su card, así que un paso sin
 *  nombre (o sin herramienta activa) deja un solo card, y sin ninguno devuelve
 *  `""` — quien llama usa eso para ocultar la fila entera. */
export function fx_filaAvisos(
  nombrePaso: AvisoPaso,
  ayudaHerramienta: string | null,
  error: string | null = null,
): string {
  const paso = fx_cardAviso(nombrePaso.icono, nombrePaso.texto, "info");
  return error
    ? `${paso}${fx_cardAviso(ICONO_ERROR, error, "error")}`
    : `${paso}${fx_cardAviso(ICONO_AYUDA, ayudaHerramienta, "info")}`;
}

function fx_cardAviso(
  icono: string,
  texto: string | null,
  tono: "info" | "error",
): string {
  if (!texto) return "";
  return `<div class="sx-alert sx-alert-${tono} map-aviso-card"><i class="ph ${icono}"></i><span>${texto}</span></div>`;
}
